exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".a-switch{display:flex;align-items:center}.a-switch span{color:#112363;font-size:14px;margin-right:10px}", ""]);

// exports
